import dayjs from 'dayjs';

const currentDay = dayjs && dayjs().format('DD');
const currentMonth = dayjs && dayjs().format('MM');

const currentYear = dayjs && dayjs().format('YYYY');

const getTime = (time, dayOffset = 0) =>
  dayjs(`${currentYear}-${currentMonth}-${currentDay} ${time}`)
    .add(dayOffset, 'day')
    .format('YYYY-MM-DD HH:mm:ss');

export const eventList = [
  {
    id: '1',
    title: 'Project Deadline',
    category: 'workshop',
    start: `${currentYear}-${currentMonth}-02 00:00:00`,
    end: `${currentYear}-${currentMonth}-04 12:59:00`,
    allDay: true,
    description: 'Important deadline for project completion. Ensure all tasks are finalized.',
    eventType: 'hybrid',
    location: '',
    url: '',
  },
  {
    id: '2',
    title: 'Team Meeting',
    category: 'meeting',
    start: `${currentYear}-${currentMonth}-${currentDay} 10:05:00`,
    end: `${currentYear}-${currentMonth}-${currentDay} 11:55:00`,
    allDay: false,
    description: 'Weekly team sync-up to discuss progress and blockers.',
    eventType: 'hybrid',
    location: '',
    url: '',
  },
  {
    id: '3',
    title: 'Client Call',
    category: 'party',
    start: `${currentYear}-${currentMonth}-01 11:05:00`,
    end: `${currentYear}-${currentMonth}-01 11:55:00`,
    allDay: false,
    description: 'Discussion with the client regarding project updates and feedback.',
    eventType: 'hybrid',
    location: '',
    url: '',
  },
  {
    id: '4',
    title: 'Company Event',
    category: 'webinar',
    start: `${currentYear}-${currentMonth}-15 00:00:00`,
    end: `${currentYear}-${currentMonth}-16 12:59:00`,
    allDay: true,
    description: 'Company-wide event to celebrate milestones and achievements.',
    eventType: 'hybrid',
    location: '',
    url: '',
  },
  {
    id: '5',
    title: 'Weekly Sync-up',
    category: 'webinar',
    start: `${currentYear}-${currentMonth}-16 00:00:00`,
    end: `${currentYear}-${currentMonth}-17 12:59:00`,
    allDay: true,
    description: 'Regular check-in to align on team priorities and tasks for the week.',
    eventType: 'hybrid',
    location: '',
    url: '',
  },
];

export const taskList = [
  {
    id: '6',
    title: 'Kickoff',
    start: `${currentYear}-${currentMonth}-${currentDay} 10:55:00`,
    end: `${currentYear}-${currentMonth}-${currentDay}`,
    allDay: false,
    description: 'Discuss project goals and timelines.',
    selectedList: 'work',
    repeated: 'weekly',
  },
  {
    id: '7',
    title: 'Code Review',
    start: `${currentYear}-${currentMonth}-${currentDay} 15:05:00`,
    end: `${currentYear}-${currentMonth}-${currentDay}`,
    allDay: false,
    description: 'Review PRs and discuss improvements.',
    selectedList: 'development',
    repeated: 'weekly',
  },
  {
    id: '8',
    title: 'Appointment',
    start: `${currentYear}-${currentMonth}-07 09:05:00`,
    end: `${currentYear}-${currentMonth}-07`,
    allDay: false,
    description: 'Annual health checkup.',
    selectedList: 'personal',
    repeated: 'weekly',
  },
  {
    id: '9',
    title: 'Team Lunch',
    start: `${currentYear}-${currentMonth}-10 13:05:00`,
    end: `${currentYear}-${currentMonth}-10`,
    allDay: false,
    description: 'Casual team bonding over lunch.',
    selectedList: 'work',
    repeated: 'weekly',
  },
  {
    id: '10',
    title: 'Reports',
    start: `${currentYear}-${currentMonth}-12 16:05:00`,
    end: `${currentYear}-${currentMonth}-12`,
    allDay: false,
    description: 'Submit weekly progress report to management.',
    selectedList: 'work',
    repeated: 'weekly',
  },
];

export const appointments = [
  {
    id: '1',
    title: 'Boot Camp',
    description: 'Boot camp',
    start: getTime('00:05:00', -1),
    end: getTime('00:50:00', -1),
    location: 'Gym',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '2',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('01:05:00'),
    end: getTime('03:30:00'),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '3',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('02:05:00', 1),
    end: getTime('03:55:00', 1),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '4',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('04:05:00', 3),
    end: getTime('04:55:00', 3),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '5',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('06:05:00', -1),
    end: getTime('07:25:00', -1),
    location: '',
    url: 'https://meet.google.com',
    allDay: false,
    category: 'task',
  },
  {
    id: '6',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('17:05:00', -1),
    end: getTime('18:55:00', -1),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '7',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('01:05:00', 1),
    end: getTime('01:55:00', 1),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '8',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('06:05:00', 2),
    end: getTime('07:55:00', 2),
    location: '',
    url: 'https://meet.google.com',
    category: 'task',
    allDay: false,
  },
  {
    id: '9',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('', 2),
    end: getTime('', 2),
    location: '',
    url: 'https://meet.google.com',
    allDay: true,
    category: 'task',
  },
  {
    id: '10',
    title: 'Team Meeting',
    description: 'Boot camp',
    start: getTime('', -2),
    end: getTime('', -2),
    location: '',
    url: 'https://meet.google.com',
    allDay: true,
    category: 'task',
  },
];

export const eventCategories = [
  { label: 'Meeting', value: 'meeting', color: 'primary' },
  { label: 'Conference', value: 'conference', color: 'secondary' },
  { label: 'Workshop', value: 'workshop', color: 'error' },
  { label: 'Webinar', value: 'webinar', color: 'info' },
  { label: 'Party', value: 'party', color: 'success' },
  { label: 'WEEKEND', value: 'WEEKEND', color: 'primary' },
  { label: 'PUBLIC', value: 'PUBLIC', color: 'success' },
  { label: 'BIRTHDAY', value: 'BIRTHDAY', color: 'secondary' },
];

export const categoryColorMap = {
  meeting: 'primary',
  PUBLIC: 'success',
  WEEKEND: 'primary',
  conference: 'secondary',
  webinar: 'info',
  workshop: 'error',
  party: 'success',
  training: 'warning',
  birthday: 'secondary',
};
